import { FC } from 'react';

import SuccessIcon from '@/assets/table/cell/success.svg';

//import { STATUS_ICONS } from '@/consts/status';

interface IStatusCell {
  icon?: string;
  title?: string;
}

const StatusCell: FC<IStatusCell> = ({ icon, title }) => {
  //const iconPath = icon ? STATUS_ICONS[icon] : undefined;

  return (
    <div className="flex items-center gap-4">
      <img src={SuccessIcon} alt={icon} />
      <div className="text-[15px]">{title}</div>
    </div>
  );
};

export default StatusCell;
